module.exports = {
          srcSet: __webpack_public_path__ + "public/91966a43f0ac7b30420e3650b5361787-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/91966a43f0ac7b30420e3650b5361787-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/91966a43f0ac7b30420e3650b5361787-80.png",
          toString:function(){return __webpack_public_path__ + "public/91966a43f0ac7b30420e3650b5361787-80.png"},
          
          width: 80,
          height: 80
        }